export class Navigation {
	private readonly element: HTMLElement = document.querySelector('#container > header') as HTMLElement;
	private readonly contentDiv: HTMLDivElement = this.element.children[0] as HTMLDivElement;
	private readonly shade: HTMLDivElement = document.createElement('div');
	private readonly mobileTrigger: HTMLButtonElement = document.getElementById('mobile-nav-trigger') as HTMLButtonElement;

	public static init(): void {
		new Navigation();
	}

	constructor() {
		this.contentDiv.append(this.shade);
		this.mobileTrigger.addEventListener('click', () => this.toggle());
		this.shade.addEventListener('click', () => this.toggle(false));
		window.addEventListener('hashchange', () => this.toggle(false));
	}

	private toggle(force?: boolean): void {
		document.body.classList.toggle('nav-open', force);
	}
}
